"use client";

import { useRef } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndividualApproach() {
  const services = [{
    number: "01",
    title: "Systemické konstelace",
    paragraphs: [".sMetoda pracující s vědomím rodinných systémů a vztahů. Odhaluje skryté vzorce a zablokované energie v rodině, které ovlivňují naši současnost. Pomoha redukovat zátěž z rodinného pole a obnovit pocit sounáležitosti a harmonie v životě. syst.."],
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/systemic_constellations_harmony.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/systemic_constellations_harmony.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/systemic_constellations_harmony.webp-wvc-sizes",
      alt: "Symbolické zobrazení rodinných a systémových vazeb"
    },
    caption: {
      title: "Řád a rovnováha",
      year: "2024",
      location: "Praha, Česká republika",
      medium: "Skupinová terapie"
    },
    link: {
      to: "/ContactPage"
    }
  }, {
    number: "02",
    title: "SCIO feedback",
    paragraphs: ["Pokročilá technologie biofeedbacku, která analyzuje stresové faktory v těle na energetické úrovni. Pomáhá identifikovat nerovnováhy a jemně stimuluje organismus k návratu do harmonického stavu a vitality."],
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/scio_feedback_technology.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/scio_feedback_technology.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/scio_feedback_technology.png-wvc-sizes",
      alt: "Moderní biofeedback technologie pro analýzu těla"
    },
    caption: {
      title: "Digitální harmonie",
      year: "2024",
      location: "Brno, Česká republika",
      medium: "Kvantová analýza"
    }
  }, {
    number: "03",
    title: "Bachovy esence",
    paragraphs: ["Čistě přírodní cesta k emoční rovnováze. 38 květových esencí pomáhá zvládat strach, nejistotu, únavu nebo osamělost. Jsou bezpečné pro dospělé i děti a jemně ladí naši psychiku zpět do klidu."],
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/bach_flower_essences_nature.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/bach_flower_essences_nature.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/bach_flower_essences_nature.png-wvc-sizes",
      alt: "Detailní záběr na květiny a přírodní esence"
    },
    caption: {
      title: "Síla přírody",
      year: "2024",
      location: "Přírodní klinika",
      medium: "Květová terapie"
    }
  }, {
    number: "04",
    title: "Odpínání",
    paragraphs: ["Práce s podvědomím v hlubokém stavu relaxace. Umožňuje přepsat omezující vzorce chování, uvolnit stará traumata a aktivovat vnitřní zdroje pro pozitivní změnu v životě."],
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/hypnosis_subconscious_mind.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/hypnosis_subconscious_mind.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/hypnosis_subconscious_mind.png-wvc-sizes",
      alt: "Abstraktní vizualizace hlubokého stavu relaxace"
    },
    caption: {
      title: "Hluboký klid",
      year: "2024",
      location: "Terapeutický ateliér",
      medium: "Regresní terapie"
    }
  }, {
    number: "05",
    title: "Kurzy",
    paragraphs: ["Partnerství zaměřené na budoucnost a vaše cíle. Pomocí cílených otázek a technik objevujeme vaše silné stránky, překonáváme vnitřní bloky a tvoříme konkrétní kroky k životu, který chcete žít."],
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/coaching_personal_growth.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/coaching_personal_growth.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578236/img/coaching_personal_growth.png-wvc-sizes",
      alt: "Inspirativní prostředí pro osobní rozvoj"
    },
    caption: {
      title: "Cesta k cíli",
      year: "2024",
      location: "Individuální sezení",
      medium: "Osobní mentoring"
    }
  }];
  const heading = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const reveal0 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reveal1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reveal2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reveal3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reveal4 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const serviceReveals = [reveal0, reveal1, reveal2, reveal3, reveal4];
  return;
}